/* eslint-disable */
import React, { forwardRef, useState } from "react";
import { Modal } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import AddLeaveRequestForm from "./leaveForm";

type AddLeaveRequestModalProps = {
  opened: boolean;
  onClose: () => void;
};

function AddLeaveRequestModal({ opened, onClose }: AddLeaveRequestModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={`Add My Leave  `}
        onClose={onClose}
        ariaLabel="Close add members modal"
      />

      <AddLeaveRequestForm onClose={onClose} />
    </Modal>
  );
}

export default AddLeaveRequestModal;
